<script>
    export default {
        bind(el, binding, vnode) {
            el.addEventListener('click', function(e) {
                e.preventDefault();

                var message = "Are your sure you want to perform this action?";

                if (binding.value && binding.value != '')
                    message = binding.value;

                this.confirmDelete(message, (result) => {
                    if (result.isConfirmed) {
                        window.location.href = el.href;
                    }
                });
            });
        }
    }
</script>